module.exports = __webpack_public_path__ + "static/media/magnus.b104d1e1.png";